<template>
  <div class="login-wrap">
    <el-form label-position="left" :model="ruleForm" :rules="rules" ref="ruleForm" label-width="0px"
      class="demo-ruleForm login-container">
      <h3 class="title">Login to your account</h3>
      <el-form-item prop="name">
        <el-input type="text" v-model="ruleForm.name" auto-complete="off" placeholder="name"></el-input>
      </el-form-item>
      <el-form-item prop="password">
        <el-input type="password" v-model="ruleForm.password" auto-complete="off" placeholder="password"></el-input>
      </el-form-item>
      <el-form-item style="width:100%;">
        <el-button type="primary" style="width:100%;" @click="submitForm('ruleForm')" :loading="logining">Login
        </el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
  import {
    login
  } from '../api/apiFun'
  import {
    setCookie,
  } from '../utils/util'
  export default {
    name: 'login',
    data() {
      return {
        //定义loading默认为false
        logining: false,
        ruleForm: {
          name: '',
          password: '',
        },
        //rules前端验证
        rules: {
          name: [{
            required: true,
            message: 'Please input name',
            trigger: 'blur'
          }],
          password: [{
            required: true,
            message: 'Please enter password',
            trigger: 'blur'
          }]
        }
      }
    },
    methods: {
      //获取info列表
      submitForm(formName) {
        this.$refs[formName].validate(valid => {
          if (valid) {
            this.logining = true
            login(this.ruleForm).then(res => {
              if (res.code == 200) {
                //如果请求success就让他2秒跳转路由
                setTimeout(() => {
                  this.logining = false
                  //Save帐号到cookie，有效期365天
                  setCookie('dkh_user', this.ruleForm.name, 8760)
                  // 缓存token4小时
                  setCookie('dkh_token', 'Bearer ' + res.datas.token, 24)
                  setCookie('group_name', res.datas.group_name, 24)
                  this.$router.push({
                    path: 'home/index'
                  })
                }, 1000)
              } else {
                this.$message.error(res.msg)
                this.logining = false
                return false
              }
            })
          } else {
            this.$message.error('Please enter username and password!')
            this.logining = false
            return false
          }
        })
      },
    }
  }

</script>
<style scoped>
  .login-wrap {
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    padding-top: 13%;
    background-color: #063a4f;
    background-image: url('https://mango-maxshopping.com/uploads/landing-page-pattern.webp');
    background-repeat: no-repeat;
    background-position: center right;
    background-size: 100%;
  }

  .login-container {
    padding: 30px 35px;
    text-align: left;
    width: 100%;
    max-width: 480px;
    margin: 0 auto;
    background: #fff;
    border: 1px solid rgba(6, 58, 79, .05);
    box-sizing: border-box;
    box-shadow: 0 13px 30px rgba(6, 58, 79, .09);
    border-radius: 8px;
  }

  .title {
    color: #002331;
    font-size: 28px;
    line-height: 36px;
    letter-spacing: .0126316em;
    font-family: Inter, Helvetica Neue, sans-serif;
    text-align: center;
    font-weight: 700;
    margin-bottom: 40px;
  }

  .el-form-item {
    margin-bottom: 32px;
  }

  .el-button--primary {
    background: linear-gradient(175.31deg, #f0aa22 -8.91%, #f05822 99.52%) #cc8b0e;
    color: #fff;
    border: none;
    min-width: 150px;
    font-weight: 700;
    min-height: 50px;
    font-size: .9375rem;
    height: 46px;
    margin: 0 auto;
    display: block;
  }

  .remember {
    margin: 0px 0px 35px 0px;
  }

</style>



// WEBPACK FOOTER //
// src/views/login.vue